import styled from 'styled-components'
import { Button, TableHead, TableContainer, TableCell } from '@material-ui/core'
import { Image } from 'ui'

export const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  padding: 0 20px 0 18px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
export const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  gap: 23.991px;
  flex-shrink: 0;
  align-self: stretch;
`
export const Title = styled.div`
  color: #0F172A;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
`
export const TableBar = styled.div`
  display: flex;
  width: 100%;
  margin-top: 31px;
  padding: 1px 1px 1px 1px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
  background: #FFF;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
`
export const BackHeader = styled.div`
  display: flex;
  width: 178px;
  justify-content: space-between;
  align-items: center;
`
export const BackHeaderText = styled.div`
  color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
`
export const HeaderTitleContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 11.989px;
`
export const BackButton = styled(Button)`
  display: flex;
  width: 37.813px;
  min-width: 38px;
  height: 37.813px;
  padding: 8.906px 8.906px 8.909px 8.906px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  border: 0.909px solid #D1D5DC;
`
export const HeaderTitle1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
`
export const TitleMain = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  color: #101828;
  text-align: right;
  font-family: Rubik;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; /* 120% */
`
export const TitleSecond = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  color: #4C5564;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400; 
  line-height: 24px; /* 150% */
`

export const HeaderIcon = styled.div`
  display: flex;
  width: 51.605px;
  height: 51.605px;
  padding: 13.807px 13.807px 1.818px 13.807px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1.818px solid #FFD230;
  background: #FEF3C6;
`

export const TableHeadStyled = styled(TableHead)`
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.95);
`

export const TableContainerStyled = styled(TableContainer)`
  max-height: 520px;
`

// 'start', not 'right': the column follows the UI language, so it reads from
// the right in Hebrew and from the left once the app is switched to English.
export const TableCellStyled = styled(TableCell)`
  border-bottom: 0.909px solid #E2E8F0;
  text-align: start;
`

// Category and version sit centred under their header instead.
export const TableCellCentered = styled(TableCellStyled)`
  text-align: center;
`

// The header cells are identical on both tables - keep a single definition.
export { HeadCell, HeadCellCentered } from './Protocols.styles'

export const TitleCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`

export const CategoryBadge = styled.div`
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 0.909px solid #3B82F6;
  background: rgba(59, 130, 246, 0.13);
  color: #1447E6;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
`

export const DateCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
`

export const AuthorCell = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
`

export const VersionCell = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
`
export const ActionImage = styled(Image)`
    margin-top: -20px;
`

export const RestoreButton = styled(Button)`
  display: flex;
  padding: 6px 12px 6px 12px;
  justify-content: center;
  align-items: flex-end;
  gap: 3.278px;
  border-radius: 8px;
  background: #DCFCE7;
  color: #008236;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const DeleteButton = styled(Button)`
  display: flex;
  padding: 5.813px 11.989px 6.176px 11.989px;
  justify-content: center;
  align-items: flex-end;
  gap: 3.009px;
  border-radius: 8px;
  background: #FFE2E2;
  color: #C10007;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
